export const AVAILABLE_CASES = 'availableCases'
export const CURRENT_CASE_ID = 'currentCaseId'
export const SET_CURRENT_CASE_ID = 'setCurrentCaseId'
export const CURRENT_CASE = 'currentCase'
export const CURRENT_USER = 'currentUser'
export const MODAL = 'modal'
